import { NgModule } from '@angular/core';

import { ActionDirective } from './action.directive';

@NgModule({
  declarations: [ActionDirective],
  exports: [ActionDirective],
})
export class KebActionModule {}
